import { TooltipEchartsOption } from '@models';
import { EChartsOption } from 'echarts';

export const BAR_CHART_OPTION: EChartsOption = {
  grid: {
    left: '10%',
    right: '5%',
    top: '10%',
    bottom: '25%',
    containLabel: true
  },
  xAxis: {
    show: true,
    minInterval: 1,
    splitNumber: 3,
    name: 'Number of studies',
    nameLocation: 'middle',
    nameTextStyle: {
      padding: 15,
      color: 'rgba(27, 27, 29, 1)'
    },
    type: 'value',
    axisLine: {
      show: true
    },
    splitLine: {
      show: false
    },
    axisLabel: {
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  yAxis: {
    type: 'category',
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      overflow: 'break',
      width: 100,
      margin: 0,
      align: 'right',
      padding: [0, 10, 0, 0],
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  series: [
    {
      type: 'bar',
      itemStyle: {
        color: '#25a1be'
      }
    }
  ]
};

export const BAR_TRUNCATED_CHART_OPTION: TooltipEchartsOption = {
  grid: {
    left: '10%',
    right: '5%',
    top: '10%',
    bottom: '25%',
    containLabel: true
  },
  tooltip: {
    show: true,
    trigger: 'axis',
    axisPointer: {
      type: 'none'
    }
  },
  xAxis: {
    show: true,
    minInterval: 1,
    name: 'Number of studies',
    nameLocation: 'middle',
    nameTextStyle: {
      padding: 15,
      color: 'rgba(27, 27, 29, 1)'
    },
    type: 'value',
    axisLine: {
      show: true
    },
    splitLine: {
      show: false
    },
    axisLabel: {
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  yAxis: {
    type: 'category',
    // triggerEvent allows axis label mouse events; we rely on axisPointer + tooltip.
    triggerEvent: true,
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      overflow: 'truncate', // visual truncation; tooltip uses original axisValue
      width: 100,
      margin: 0,
      align: 'right',
      padding: [0, 10, 0, 0],
      color: 'rgba(27, 27, 29, 1)'
    },
    tooltip: {
      show: true,
      position: 'top',
      padding: 5,
      textStyle: {
        fontSize: 12,
        color: '#000000'
      }
    }
  },
  series: [
    {
      type: 'bar',
      tooltip: {
        show: false
      },
      itemStyle: {
        color: '#25a1be'
      }
    }
  ]
};

export const PIE_CHART_OPTION: EChartsOption = {
  series: [
    {
      type: 'pie',
      radius: ['35%', '60%'],
      center: ['50%', '40%'],
      startAngle: 225,
      avoidLabelOverlap: false,
      itemStyle: {
        borderRadius: 0,
        borderColor: '#fff',
        borderWidth: 2
      },
      label: {
        show: true,
        position: 'outer',
        edgeDistance: '10%',
        formatter: function (params) {
          let name = params.name;
          if (name === 'Y') name = 'Yes';
          else if (name === 'N') name = 'No';
          const percent = Math.round(params.percent ?? 0);
          return `${name} ${percent}%`;
        }
      },
      labelLine: {
        show: true,
        length: 10,
        length2: 10
      }
    }
  ]
};

export const GROUPED_BAR_CHART_OPTION: EChartsOption = {
  grid: {
    left: '10%',
    right: '5%',
    top: '10%',
    bottom: '25%',
    containLabel: true
  },
  xAxis: {
    show: true,
    minInterval: 1,
    name: 'Number of studies',
    nameLocation: 'middle',
    nameTextStyle: {
      padding: 15,
      color: 'rgba(27, 27, 29, 1)'
    },
    type: 'value',
    axisLine: {
      show: true
    },
    splitLine: {
      show: false
    },
    axisLabel: {
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  yAxis: {
    type: 'category',
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      overflow: 'break',
      width: 100,
      margin: 0,
      align: 'right',
      padding: [0, 10, 0, 0],
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  series: [
    {
      type: 'bar',
      itemStyle: {
        color: '#25a1be'
      }
    },
    {
      type: 'bar',
      itemStyle: {
        color: '#005DAA'
      }
    }
  ]
};

export const EXPANDED_BAR_CHART_OPTION: EChartsOption = {
  grid: {
    left: '5%',
    right: '5%',
    top: '5%',
    bottom: '20%',
    containLabel: true
  },
  xAxis: {
    show: true,
    minInterval: 1,
    name: 'Number of studies',
    nameLocation: 'middle',
    nameTextStyle: {
      padding: 15,
      color: 'rgba(27, 27, 29, 1)'
    },
    type: 'value',
    axisLine: {
      show: true
    },
    splitLine: {
      show: true
    },
    axisLabel: {
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  yAxis: {
    type: 'category',
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      overflow: 'break',
      width: 100,
      margin: 0,
      align: 'right',
      padding: [0, 10, 0, 0],
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  series: [
    {
      type: 'bar',
      itemStyle: {
        color: '#25a1be'
      }
    }
  ]
};

export const EXPANDED_GROUPED_BAR_CHART_OPTION: EChartsOption = {
  grid: {
    left: '5%',
    right: '5%',
    top: '5%',
    bottom: '20%',
    containLabel: true
  },
  xAxis: {
    show: true,
    minInterval: 1,
    name: 'Number of studies',
    nameLocation: 'middle',
    nameTextStyle: {
      padding: 15,
      color: 'rgba(27, 27, 29, 1)'
    },
    type: 'value',
    axisLine: {
      show: true
    },
    splitLine: {
      show: true
    },
    axisLabel: {
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  yAxis: {
    type: 'category',
    data: [],
    axisTick: {
      show: false
    },
    axisLabel: {
      interval: 0,
      overflow: 'break',
      width: 100,
      margin: 0,
      align: 'right',
      padding: [0, 10, 0, 0],
      color: 'rgba(27, 27, 29, 1)'
    }
  },
  series: [
    {
      type: 'bar',
      itemStyle: {
        color: '#25a1be'
      }
    },
    {
      type: 'bar',
      itemStyle: {
        color: '#005DAA'
      }
    }
  ]
};

export const KPI_EXPANDED_BAR_CHART_OPTION: EChartsOption = {
  ...EXPANDED_BAR_CHART_OPTION,
  grid: {
    ...EXPANDED_BAR_CHART_OPTION.grid,
    top: '2%',
    bottom: '10%'
  },
  xAxis: {
    ...EXPANDED_BAR_CHART_OPTION.xAxis,
    name: ''
  },
  yAxis: {
    ...EXPANDED_BAR_CHART_OPTION.yAxis,
    axisLabel: {
      ...(EXPANDED_BAR_CHART_OPTION.yAxis as any).axisLabel,
      overflow: 'truncate',
      margin: 10
    }
  }
};

export const KPI_EXPANDED_GROUPED_BAR_CHART_OPTION: EChartsOption = {
  ...EXPANDED_GROUPED_BAR_CHART_OPTION,
  grid: {
    ...EXPANDED_GROUPED_BAR_CHART_OPTION.grid,
    top: '2%',
    bottom: '10%'
  },
  xAxis: {
    ...EXPANDED_GROUPED_BAR_CHART_OPTION.xAxis,
    name: ''
  },
  yAxis: {
    ...EXPANDED_GROUPED_BAR_CHART_OPTION.yAxis,
    axisLabel: {
      ...(EXPANDED_GROUPED_BAR_CHART_OPTION.yAxis as any).axisLabel,
      overflow: 'truncate',
      margin: 10
    }
  }
};

export const PIE_CHART_COLOR_MAPPING: Record<string, string> = {
  Y: '#25a1be',
  N: '#005DAA',
  O: '#de7a00',
  R: '#b60150',
  P: '#4a42cd'
};

export const INIT_CHART_OPTION_SMALL = {
  renderer: 'svg',
  width: 360,
  height: 190
};

export const INIT_CHART_OPTION_BIG = {
  renderer: 'svg',
  width: 1376,
  height: 515
};

export const INIT_KPI_CHART_OPTION_SMALL = {
  renderer: 'svg'
};

export const INIT_KPI_CHART_OPTION_MEDIUM = {
  renderer: 'svg'
};

export const INIT_KPI_CHART_OPTION_LARGE = {
  renderer: 'svg'
};
